import axiosInstance from '@/utils/api.js'

var state = {
  firewalls: []
}

var getters = {
  FIREWALLS: (state) => {
    return state.firewalls
  }
}

var mutations = {
  SET_FIREWALLS: (state, payload) => {
    state.firewalls = payload
  }
}

var actions = {
  GET_FIREWALLS: async (context, payload) => {
    let result = await axiosInstance.get('/settings/routers')
    if (result.status === 200) {
      context.commit('SET_FIREWALLS', result.data)
    }
  },
  CREATE_FIREWALLS: (context, payload) => {
    return axiosInstance.post('/settings/routers', payload)
  },
  UPDATE_FIREWALLS: (context, payload) => {
    return axiosInstance.put('/settings/routers', payload)
  },
  DELETE_FIREWALLS: (context, payload) => {
    return axiosInstance.delete('/settings/routers?router_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/firewalls.js